import { LocalDataSetup } from "pouchDB/LocalDataSetup";
import axios from "axios";
import { api_link } from "siteConfig";

const job_array = []
const job_array2 = []

export const MasterSync = async (subcon_id) => {
    //if subcon_id contains a , then explode
    if(subcon_id.includes(',')) {
        let subcons = subcon_id.split(',')
        subcons.forEach(subcon => {
            syncJobs(subcon).then(() => { 
                getJobs(subcon)
            })
        })
    }
    else {
        syncJobs(subcon_id).then(() => { 
            getJobs(subcon_id)
        })
    }

    removeDeletedJobs().then(() => {
        return true
    })

    await getForms()
    await syncForms()
    return true
}

async function syncForms() {
    console.log('syncing forms...')
    let url = 'https://'+api_link+'supplier_portal/rabbitmq/sync_form'
    let db_form_results_local = LocalDataSetup.db_form_results_local

    await db_form_results_local.allDocs({
        include_docs: true,
        attachments: true
    }).then(result => {
        // apply a filter to rows
        // eslint-disable-next-line
        result.rows = result.rows.filter(row => {
            let form_result = row.doc
            console.log(form_result)
            if (form_result.sync === undefined) {
                return true
            } 
        }).forEach(row => {
            let form_result = row.doc

            axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": form_result.job_id,
                    "var2": form_result.session_id,
                    "var3": form_result.user_id,
                    "var4": form_result._id,
                    "var5": form_result.completed_at,
                    "var6": form_result.answers
                },
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    // "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json"
                }
            }).then(resp => {
                // on success update sync to true   
                db_form_results_local.get(form_result._id).then(existingDoc => {
                    existingDoc.sync = true;
                    return db_form_results_local.put(existingDoc);
                }).then(() => {
                    // console.log('form synced')
                }).catch(err => {
                    console.log(err)
                })
            }).catch(err => {
                console.log(err)
            })
        })
    }).catch(err => {
        console.log(err)
    })
}

async function getForms() {
    let url = 'https://'+api_link+'supplier_portal/getForms'

    let form_data = await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url
        },
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {
        return resp.data
    }).catch(err => {
        console.log(err)
    })

    insertFormHeader(form_data.form_header)
    insertFormQuestions(form_data.form_detail)
    insertFormDropdown(form_data.form_dropdown)
}

function insertFormHeader(header_array) { 

    Object.entries(header_array).forEach(r => {

        // console.log(r[1].form_name)

        LocalDataSetup.db_form_main_local.get(r[1].id).catch(function(err) {

            if (err.name === 'not_found') {
                
            LocalDataSetup.db_form_main_local.put({
                    _id: r[1].id,
                    id: r[1].id,
                    category: r[1].category,
                    form_name: r[1].form_name,
                    pdf_script: r[1].pdf_script,
                    protean_req_id: r[1].protean_req_id,
                    site_audit_req: r[1].site_audit_req,
                    cylinder_link: r[1].cylinder_link,
                    continuation: r[1].continuation,
                    pdf_generation: r[1].pdf_generation,
                    status: r[1].status
                }).catch(function(err) {
                    if (err.name === 'conflict') {
                        console.log(err);
                    }
                });
            } 
                
        }).then(function(response) {
            LocalDataSetup.db_form_main_local.put({
                _id: r[1].id,
                _rev: response._rev,
                id: r[1].id,
                category: r[1].category,
                form_name: r[1].form_name,
                pdf_script: r[1].pdf_script,
                protean_req_id: r[1].protean_req_id,
                site_audit_req: r[1].site_audit_req,
                cylinder_link: r[1].cylinder_link,
                continuation: r[1].continuation,
                pdf_generation: r[1].pdf_generation,
                status: r[1].status
            }).catch(function(err) {
                if (err.name === 'conflict') {
                    console.log(err);
                }
            });
            return response;
        }).catch(function (err) {
            // handle any errors
            console.log(err);
        });
    });

}

function insertFormDropdown(dropdown_array) { 

    Object.entries(dropdown_array).forEach(r => {
        // console.log(r[1].name)

        LocalDataSetup.db_form_dropdown_local.get(r[1].id).catch(function(err) {
            if (err.name === 'not_found') {
                
            LocalDataSetup.db_form_dropdown_local.put({
                    _id: r[1].id,
                    main_id: r[1].main_id,
                    q_id: r[1].q_id,
                    value: r[1].value,
                    position: r[1].position
                }).catch(function(err) {
                    if (err.name === 'conflict') {
                        console.log(err);
                    }
                });
            } 
        }).then(function(response) {
            LocalDataSetup.db_form_dropdown_local.put({
                _id: r[1].id,
                _rev: response._rev,
                main_id: r[1].main_id,
                q_id: r[1].q_id,
                value: r[1].value,
                position: r[1].position
            }).catch(function(err) {
                if (err.name === 'conflict') {
                    console.log(err);
                }
            });
            return response;
        }).catch(function (err) {
            // handle any errors
            console.log(err);
        });

    })

}

function insertFormQuestions(questions_array) { 

    Object.entries(questions_array).forEach(r => {

        // console.log(r[1].form_name)

        LocalDataSetup.db_form_question_local.get(r[1].main_id).catch(function(err) {

            if (err.name === 'not_found') {
                
            LocalDataSetup.db_form_question_local.put({
                    _id: r[1].main_id,
                    main_id: r[1].main_id,
                    questions: r[1].questions
                }).catch(function(err) {
                    if (err.name === 'conflict') {
                        console.log(err);
                    }
                });
            } 
                
        }).then(function(response) {
            LocalDataSetup.db_form_question_local.put({
                _id: r[1].main_id,
                _rev: response._rev,
                main_id: r[1].main_id,
                questions: r[1].questions
            }).catch(function(err) {
                if (err.name === 'conflict') {
                    console.log(err);
                }
            });
            return response;
        }).catch(function (err) {
            // handle any errors
            console.log(err);
        });
    });

}

async function syncJobs(subcon_id) {
    let url = 'https://'+api_link+'supplier_portal/rabbitmq/sync_job'
    let db_jobs_local = LocalDataSetup.db_jobs_local

    await db_jobs_local.allDocs({
        include_docs: true,
        attachments: true
    }).then(result => {
        // apply a filter to rows
        // eslint-disable-next-line
        result.rows = result.rows.filter(row => {
            // filter to any jobs where Status is > 250 and less that 800 Or have been completed in the last 2 days
            let job = row.doc.job
            let status = parseInt(job.Status)
            // console.log(job)

            if (status > 250 && status <= 800) {
                return true
            } 

        }).forEach(row => {
            let job = row.doc.job

            axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": job.JobID,
                    "var2": job.SessionID,
                    "var3": job.ArrivalTimeEstimated,
                    "var4": job.TimeOn1,
                    "var5": job.TimeOff1,
                    "var6": job.WorkReport,
                    "var7": job.QuoteRequired,
                    "var8": job.QuoteDetails,
                    "var9": job.RevisitRequired,
                    "var10": job.RevisitDetails,
                    "var11": job.Status,
                    "var12": job.VisitDate
                },
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    // "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json"
                }
            }).then(resp => {
            }).catch(err => {
                console.log(err)
            })
        })
    }).catch(err => {
        console.log(err)
    })
}

async function getJobs(subcon_id) {
    let url = 'https://'+api_link+'supplier_portal/getJobs'
    let db_jobs_local = LocalDataSetup.db_jobs_local

    await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url,
            "var1": subcon_id
        },
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {
        let jobs = resp.data
        let jobs_docs = []

        jobs.forEach(job => {
            //if(job.Status === 1111) do not add to array
            if(parseInt(job.Status) === 1111) {
                job_array2.push(job.JobID+'*'+job.SessionID)
                return;
            }
            let doc = {
                _id: job.JobID+'*'+job.SessionID,
                job: job
            }
            jobs_docs.push(doc)
            // puch jobid to array
            job_array.push(job.JobID+'*'+job.SessionID)
            job_array2.push(job.JobID+'*'+job.SessionID)
        })

        //iterate through jobs and add or update local db
        jobs_docs.forEach(doc => {
            db_jobs_local.get(doc._id).then(row => {
                // console.log(row)
                // Update visitdate always
                row.job.VisitDate = doc.job.VisitDate;
                row.job.StatusDesc = doc.job.StatusDesc;
                
                // Update status only if timeon1, timeoff1, and workreport are blank
                if (row.job.TimeOn1 === '' || row.job.TimeOn1 === null
                    || row.job.TimeOff1 === '' || row.job.TimeOff1 === null
                    || row.job.WorkReport === '' || row.job.WorkReport === null
                    || parseInt(doc.job.Status) !== 1111) {
                    row.job.Status = doc.job.Status;
                }
                
                db_jobs_local.put({
                    _id: row._id,
                    _rev: row._rev,
                    job: row.job
                }).then(() => {
                    // console.log('updated')
                }).catch(err => {
                    // console.log(err)
                })
            }).catch(err => {
                db_jobs_local.put(doc).then(() => {
                    // console.log('added')
                }).catch(err => {
                    // console.log(err)
                })
            })
        })

    }).catch(err => {
        console.log(err)
    })
}

async function removeDeletedJobs(){

    console.log(job_array2)

    let db_jobs_local = LocalDataSetup.db_jobs_local
    // compare the local jobs to the job_array and where a job is missing from the job_array delete it from the local db
    db_jobs_local.allDocs({
        include_docs: true,
        attachments: true
    }).then(result => {
        // apply a filter to rows
        // eslint-disable-next-line
        result.rows = result.rows.filter(row => {
            let job = row.doc.job
            let job_id = job.JobID
            let session_id = job.SessionID
            let status = job.Status

            if(status >= 220 && status < 800) {
                if (!job_array2.includes(job_id+'*'+session_id)) {
                    db_jobs_local.remove(row.doc).then(() => {
                        // console.log('deleted')
                    }).catch(err => {
                        // console.log(err)
                    })
                }
            }
        })
    }).catch(err => {
        console.log(err)
    })
}